<div class="m-defective-flow-container">
  <ng-container *ngIf="isOperationSelectionStep">
    <monorepo-operation-or-reject-reason-selection
      [bctxHeader]="bctxHeader"
      [allOperationOrRejectReasonList]="allOperationList"
      [operationOrRejectReasonList]="operationList"
      [selectedOperationOrRejectReasonList]="selectedOperationList"
      (cancel)="handleCancel()"
      (next)="handleOperationOrRejectReasonSelectionNext($event)"
      (clearAll)="handleOperationClearAll()"
      (onViewAll)="onViewAll($event, true)"
    ></monorepo-operation-or-reject-reason-selection
  ></ng-container>
  <ng-container *ngIf="isRecentDefectiveSelectionStep">
    <monorepo-operation-or-reject-reason-selection
      [bctxHeader]="bctxHeader"
      [operationOrRejectReasonList]="recentDefectiveList"
      [isRecentDefectiveSelection]="isRecentDefectsSelection"
      [selectedOperationOrRejectReasonList]="selectedRecentDefectiveList"
      (cancel)="handleCancel()"
      (next)="handleOperationOrRejectReasonSelectionNext($event)"
      (clearAll)="handleOperationClearAll()"
    ></monorepo-operation-or-reject-reason-selection
  ></ng-container>
  <ng-container *ngIf="isIssueSelectionStep">
    <monorepo-issue-selection
      [allIssueList]="allIssueList"
      [issueList]="issueList"
      [operationAndSelectedIssueList]="operationAndSelectedIssueList"
      (back)="handleIssueSelectionBack($event)"
      (cancel)="handleCancel()"
      (next)="handleIssueSelectionNext($event)"
      (clearAll)="handleIssueClearAll()"
      (viewAll)="onViewAll($event, false)"
    ></monorepo-issue-selection>
  </ng-container>
  <ng-container *ngIf="isMarkLocationStep">
    <monorepo-mark-location
      [operationIssueAndMarkedLocationsList]="operationIssueAndMarkedLocationsList"
      [silhouette_front]="silhouette_front"
      [silhouette_back]="silhouette_back"
      [shillohutteId]="silhoutteId"
      (cancel)="handleCancel()"
      (back)="handleMarkLocationBack($event)"
      (done)="handleDone($event)"
      (clearAll)="handleMarkLocationClearAll()"
      [isImageCapturingEnabled]="isImageCapturingEnabled"
      (addPhoto)="openCamera()"
    ></monorepo-mark-location>
  </ng-container>
</div>
